'use strict';

module.exports = {
  apiHost: 'https://ireland-stage-developer-api.august.com',
};
